export const CHINESE_LANGUAGE_ID = 'zh';
export const TRADITIONAL_CHINESE_LANGUAGE_ID = 'zh-t';
export const CHINESE_CULTURE_LANGUAGE_OPTIONS = [
  { id: 'cn', label: 'Mandarin' },
  { id: 'hk', label: 'Cantonese' },
];
